import {Card} from "react-bootstrap";
import ReactJson from "react18-json-view";
import PropTypes from "prop-types";

export const JsonViewer = (props) => {

    if (!props.show) {
    return <></>
    }
    return (
        <pre className={ props.className || 'position-relative'}>
            <Card className={'p-2'}>
              <Card.Body>
                  <ReactJson src={props.src || {}} style={{fontSize: 11}} collapsed={true}/>
                  </Card.Body>
            </Card>
        </pre>)

}

JsonViewer.propTypes = {
    src: PropTypes.any.isRequired,
    show: PropTypes.bool,
    className: PropTypes.string,
}